import { SelectedOptionE } from "../models/enums";
import { PackageTypeRouteT } from "../models/models";

/**
 * Return option list for JUMBOcodes purchase page
 * and for default plans purchase page.
 */

const getOptionList = (packageType?: PackageTypeRouteT) => {
  if (!packageType) {
    return [];
  }

  // JUMBOcodes page
  if (packageType === "pay-as-you-go") {
    return [
      SelectedOptionE.FIVE_CODES,
      SelectedOptionE.TEN_CODES,
      SelectedOptionE.TWENTY_CODES,
    ];
  } else if (
    packageType === "pro" ||
    packageType === "business" ||
    packageType === "premium"
  ) {
    return [SelectedOptionE.YEARLY, SelectedOptionE.MONTHLY];
  }
};

export default getOptionList;
